import { Link } from "react-router-dom";
import { LAATSTE_IMPORT } from "@/data/products";

export const SiteFooter = () => (
  <footer className="mt-20 border-t border-border bg-secondary/40">
    <div className="container grid gap-10 py-12 md:grid-cols-4">
      <div className="space-y-2">
        <p className="font-semibold">ISDE Meldcode Zoeker</p>
        <p className="text-sm text-muted-foreground">
          Onafhankelijke zoekmachine op basis van de officiële RVO-meldcodelijsten.
        </p>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-semibold">Categorieën</p>
        <ul className="space-y-1 text-muted-foreground">
          <li><Link className="hover:text-primary" to="/categorie/warmtepompen">Warmtepompen</Link></li>
          <li><Link className="hover:text-primary" to="/categorie/zonneboilers">Zonneboilers</Link></li>
          <li><Link className="hover:text-primary" to="/categorie/isolatiematerialen">Isolatie</Link></li>
          <li><Link className="hover:text-primary" to="/categorie/hoogrendementsglas">HR-glas</Link></li>
          <li><Link className="hover:text-primary" to="/categorie/ventilatie-units">Ventilatie</Link></li>
        </ul>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-semibold">Informatie</p>
        <ul className="space-y-1 text-muted-foreground">
          <li><Link className="hover:text-primary" to="/datakwaliteit">Datakwaliteit & bron</Link></li>
          <li><Link className="hover:text-primary" to="/disclaimer">Disclaimer</Link></li>
          <li><Link className="hover:text-primary" to="/affiliate-disclosure">Affiliate disclosure</Link></li>
          <li><Link className="hover:text-primary" to="/niet-gevonden">Meld ontbrekende code</Link></li>
        </ul>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-semibold">Laatste import</p>
        <p className="text-muted-foreground">{LAATSTE_IMPORT}</p>
        <p className="text-xs text-muted-foreground">
          Wij zijn niet de RVO. Controleer voor je aanvraag altijd de officiële informatie.
        </p>
      </div>
    </div>
    <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} ISDE Meldcode Zoeker — onafhankelijk informatief platform.
    </div>
  </footer>
);
